var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"40px 0 0px 0"},attrs:{"id":"pre-paid"}},[_c('div',{staticClass:"upper-content"},[_c('lines-card',{attrs:{"error":_vm.error,"load":_vm.load,"data":_vm.data.html}}),_c('additional-info-card',{attrs:{"load":_vm.load,"error":_vm.error,"data":_vm.data.additionalInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }